



























































































































import WorkerProfileDto from '@/models/Workers/WorkerProfileDto'
import { Component, Vue } from 'vue-property-decorator'
import { WorkerListModule } from '@/store/modules/workerList';
import PageNames from '@/router/PageNames';
import WorkerListSearchCriteria from '@/components/Workers/WorkerListSearchCriteria.vue';
import WorkerListEmail from '@/components/Workers/WorkerListEmail.vue';
import GeoPoint from '@/models/Shared/GeoPoint';
import PrepareForLaunch from '@/components/Shared/PrepareForLaunch.vue';
import GiganautVue from '@/components/Shared/GiganautVue';
import AddressUtils from '@/lib/addressUtils';
import Alert from '@/components/Shared/Alert.vue';
import WorkerStatus from '@/components/Workers/Display/WorkerStatus.vue';
import { AppModule } from '@/store/modules/app';

@Component({
  name: 'WorkerList',
  components: {
    WorkerListSearchCriteria, WorkerListEmail, WorkerStatus, PrepareForLaunch, Alert
  }
})
export default class extends GiganautVue {

  center: GeoPoint = {lng: 0, lat: 0};
  url = require("@/assets/img/Worker.png");
  workerInfoWindowPos: any = null;
  workerInfoWinOpen = false;
  currentWorkerIndex: any = null;
  workerInfoOptions: any = {
    content: '',
      //optional: offset infowindow so it visually sits nicely on top of our marker
      pixelOffset: {
        width: 0,
        height: -35
      }
  };

  locationInfoWindowPos: any = null;
  locationInfoWinOpen = false;
  locationInfoOptions: any = {
    content: '',
      //optional: offset infowindow so it visually sits nicely on top of our marker
      pixelOffset: {
        width: 0,
        height: -35
      }
  };

  getWorkerAvatarUrl(worker: WorkerProfileDto) {
      return AppModule.currentAgencyContext.storageSharedBaseUrl + "/avatars/3/" + worker.id + "/resized-100/" + worker.avatar;
  }

  async navigateToWorker(item: WorkerProfileDto) {
    const workerId = item.id;
    this.$router.push({ name: PageNames.AgencyWorkerDetails, params: { workerid: workerId } });
  }

  get workers(): WorkerProfileDto[] {
    return WorkerListModule.workers;
  }

  get searchOptions() {
    return WorkerListModule.workerSearchViewModel;
  }

  async centerMap(geo: GeoPoint) {
    this.center = geo;
  }

  get loading() {
    return WorkerListModule.loading;
  }

  created() {
    this.getWorkers();
  }

  private getWorkers() {
    WorkerListModule.searchWorkers();
  }

  get getRadius() {
    return Math.abs((WorkerListModule.workerSearchViewModel.selectedDistance.value * 1609));
  }

  get isProximitySearch() {
    return WorkerListModule.workerSearchViewModel.selectedLocation != null;
  }

  get locationLatLng() {
    if (this.isProximitySearch) {
      return {lng:WorkerListModule.workerSearchViewModel.selectedLocation.longitude,lat:WorkerListModule.workerSearchViewModel.selectedLocation.latitude}
    }
    return null;
  }

  async toggleWorkerInfoWindow(worker: any, idx: any) {

    this.workerInfoWindowPos = {lng:worker.longitude,lat:worker.latitude}
    this.workerInfoOptions.content = "<p class='body-2'>" + worker.firstName + ' ' + worker.lastName + "</p><p>" + AddressUtils.fullAddressLine(worker) + "</p><p><a href='" + window.location.origin + "/agency/workers/" + worker.id + "' target='_blank'>Open in new tab</a>";

    //check if its the same marker that was selected if yes toggle
    if (this.currentWorkerIndex == idx) {
      this.workerInfoWinOpen = !this.workerInfoWinOpen;
    }
    //if different marker set infowindow to open and reset current marker index
    else {
      this.workerInfoWinOpen = true;
      this.currentWorkerIndex = idx;
    }
  }

  async toggleLocationInfoWindow() {
    const selectedLocation = WorkerListModule.workerSearchViewModel.selectedLocation;
    if (selectedLocation !== null) {
    this.locationInfoWindowPos = {lng:selectedLocation.longitude,lat:selectedLocation.latitude}
    this.locationInfoOptions.content = "<p class='body-2'>" + selectedLocation.brandName + "</p><p>" + AddressUtils.fullAddressLine(selectedLocation) + "</p><p><a href='" + window.location.origin + "/agency/locations/" + selectedLocation.id + "' target='_blank'>Open in new tab</a>";

    //check if its the same marker that was selected if yes toggle
    this.locationInfoWinOpen = !this.locationInfoWinOpen;
    }
  }

  async navigateToWorkerWizard() {
    this.$router.push({
      name: PageNames.AgencyWorkerWizard,
    });
  }

  private search = '';
  
  private headers = [
    { text: '', value: 'avatar' },
    { text: 'Ref', value: 'sequenceNumber' },
    { text: 'Name', value: 'fullName' },
    { text: 'Mobile Number', value: 'mobilePhoneNumber' },
    { text: 'Email Address', value: 'emailAddress' },
    { text: 'Work Types' },
    { text: 'Status' },
    { text: 'Actions' },
  ]

}
